<template>
    <v-container class="hkiarace-banner-setting" fluid v-if="banners != null">
        <v-row>
            <v-col>
                <v-btn color="primary" @click="initAddBanner">{{$t('add')}}</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table :items="banners"
                              :headers="bannerHeaders">
                    <template v-slot:item.from_time="{item}">
                        {{DateTime.fromISO(item.from_time).toFormat('D')}}
                    </template>
                    <template v-slot:item.to_time="{item}">
                        {{DateTime.fromISO(item.to_time).toFormat('D')}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-btn icon color="primary"
                               @click="editBanner(item)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn icon color="primary"
                               @click="deleteBanner(item)">
                            <v-icon>fas fa-trash</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="showBannerEditModal">
            <v-card v-if="editingBanner" class="hkiarace-banner-setting-dialog">
                <v-card-title>{{bannerEditModalTitle}}</v-card-title>

                <v-card-text class="text-left">
                    <b-form class="hkiarace-banner-add-form">
                        <b-form-group :label="$t('admin_banner.name')"
                                      horizontal>
                            <b-form-input v-model="editingBanner.name"></b-form-input>
                        </b-form-group>
                        <b-form-group :label="$t('admin_banner.from_time')"
                                      horizontal>
                            <DateTimeInput :state="!!fromTime" v-model="fromTime"></DateTimeInput>
                        </b-form-group>
                        <b-form-group :label="$t('admin_banner.to_time')"
                                      horizontal>
                            <DateTimeInput :state="!!toTime" v-model="toTime"></DateTimeInput>
                        </b-form-group>
                        <b-form-group :label="$t('admin_banner.banner')"
                                      horizontal
                                      v-if="!uploadedBanner">
                            <b-form-file ref="banner_input"
                                         multiple
                                         accept="image/jpeg, image/png, image/jpg"
                                         @change="bannerUploaded"
                                         :placeholder="$t('admin_banner.banner')"
                                         :state="!!uploadedBanner"></b-form-file>
                        </b-form-group>
                        <b-form-group :label="$t('admin_banner.banner')"
                                      horizontal
                                      v-if="uploadedBanner">
                            <b-row class="banner-preview">
                                <b-col cols="3">
                                    <b-img thumbnail :src="getURL(uploadedBanner)"></b-img>
                                    <div class="banner-preview-remove-btn" @click="removeBanner()">
                                        <font-awesome-icon icon="times"></font-awesome-icon>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form-group>
                        <b-form-group :label="$t('admin_banner.link')"
                                      horizontal>
                            <b-form-input v-model="editingBanner.link"></b-form-input>
                        </b-form-group>
                    </b-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary"
                           @click="saveBanner()">
                        {{$t('save')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {DateTime} from 'luxon';
    import DateTimeInput from "../DateTimeInput";

    export default {
        name: 'HkiaraceBannerSetting',
        components: {DateTimeInput},
        data() {
            return {
                banners: null,
                bannerHeaders: [
                    {text: this.$t('admin_banner.name'), value: 'name'},
                    {text: this.$t('admin_banner.from_time'), value: 'from_time'},
                    {text: this.$t('admin_banner.to_time'), value: 'to_time'},
                    {text: '', value: 'actions'},
                ],

                editingBanner: null,
                showBannerEditModal: false,

                fromTime: null,
                toTime: null,
                uploadedBanner: null,

                DateTime,
            }
        },
        mounted() {
            this.getBanners();
        },
        methods: {
            getBanners() {
                this.$callAPI('hkiarace/admin/banner/', {}, function (response) {
                    this.banners = response.body.banners;
                });
            },
            initAddBanner() {
                this.bannerEditModalTitle = this.$t('admin_banner.add_title');
                this.editingBanner = {};
                this.fromTime = null;
                this.toTime = null;
                this.uploadedBanner = null;
                this.showBannerEditModal = true;
            },
            editBanner(banner) {
                this.bannerEditModalTitle = this.$t('admin_banner.edit_title');
                this.editingBanner = banner;
                this.fromTime = DateTime.fromISO(banner.from_time);
                this.toTime = DateTime.fromISO(banner.to_time);
                this.uploadedBanner = banner.banner;
                this.showBannerEditModal = true;
            },
            deleteBanner(banner) {
                if (confirm('Confirm Delete Banner?')) {
                    this.$callAPI('hkiarace/admin/banner/delete/', {id: banner.id}, function () {
                        this.getBanners();
                    })
                }
            },
            saveBanner() {
                if (!this.editingBanner.name || !this.uploadedBanner || !this.fromTime || !this.toTime) {
                    this.$showAlertMessage("Please input all fields");
                    return;
                }

                this.$uploadFiles([this.uploadedBanner], function (response) {
                    let bannerFileId;
                    if (response) {
                        let file_id_map = response.body.file_ids;

                        bannerFileId = file_id_map[this.uploadedBanner.name];
                    } else {
                        bannerFileId = this.uploadedBanner;
                    }

                    this.$callAPI('hkiarace/admin/banner/set/', {
                        id: this.editingBanner.id,
                        name: this.editingBanner.name,
                        from_time: DateTime.fromISO(this.fromTime).toSeconds(),
                        to_time: DateTime.fromISO(this.toTime).toSeconds(),
                        banner: bannerFileId,
                        link: this.editingBanner.link,
                    }, function (response) {
                        this.showBannerEditModal = false;
                        this.getBanners();
                    })
                })
            },

            removeBanner() {
                this.uploadedBanner = null;
            },
            bannerUploaded(e) {
                if (e.target.files[0]) {
                    this.uploadedBanner = e.target.files[0];

                    this.$refs['banner_input'].reset();
                }
            },
            getURL(f) {
                if (f instanceof File) {
                    return URL.createObjectURL(f);
                } else {
                    return 'api/static/' + f;
                }
            },
        },
    }
</script>

<style lang="less">
    .hkiarace-banner-setting-dialog {
        .banner-preview {
            .banner-preview-remove-btn {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                opacity: 0;
                cursor: pointer;
                transition: opacity 0.3s;

                &:hover {
                    opacity: 1;
                    transition: opacity 0.3s;
                }

                .fa-times {
                    color: white;
                    height: 50%;
                    width: 50%;
                    position: absolute;
                    left: 25%;
                    top: 25%;
                }
            }
        }
    }
</style>
